import React from "react";
import { svg } from "../../../../../Assets/svg";
import { Modal } from "antd";
import { RootState, useAppSelector } from "../../../../../store";
import { BtnLoader } from "../../../../../Components/Components";

const CreateProductionPlanConfirmationModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: any;
  handleSuccess: any;
}> = ({ visible, setIsModalVisible, onClose, handleSuccess }) => {
  const { changeOrderStatusLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );
  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Create Production Plan, Are You Sure?
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-126"
            onClick={onClose}
            disabled={changeOrderStatusLoading}
          >
            CLOSE
          </button>
          <button
            type="button"
            disabled={changeOrderStatusLoading}
            className="btn btn-lg min-w-126 btn-primary"
            onClick={handleSuccess}
          >
            {changeOrderStatusLoading ? <BtnLoader /> : "YES"}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">
          Starting production will update the order status and notify relevant
          teams. Please confirm before proceeding, as this action cannot be
          undone.
        </p>
      </div>
    </Modal>
  );
};

export default CreateProductionPlanConfirmationModal;

